jQuery( window ).load(function () {
		$('section#about a').click(function(){
			ga('send', 'event', 'Home', 'Click on About WPDI', '' );
		});
		$('section#video a').click(function(){
			ga('send', 'event', 'Home',  'Play video', '');
		});
		$('section#story a').click(function(){
			ga('send', 'event', 'Home', 'Click on Read Her/His story', '');
		});
		$('section#programs a').click(function(){
			ga('send', 'event', 'Home', 'Click on Discover our programs', '');
		});
		$('footer .subscription form').submit(function(){
			ga('send', 'event', 'Newsletter', 'Subscribe our Newsletter', '');
		});
		$('footer a .fa-facebook-f').click(function(){
			ga('send', 'event', 'Social Networks', 'Click on Facebook', '');
		});
		$('footer a .fa-instagram').click(function(){
			ga('send', 'event', 'Social Networks', 'Click on Instagram', '');
		});
		$('footer a .fa-twitter').click(function(){
			ga('send', 'event', 'Social Networks', 'Click on Twitter', '');
		});
		$('footer a .fa-youtube').click(function(){
			ga('send', 'event', 'Social Networks', 'Click on YouTube ', '');
		});
		$('header .nav>ul>li.bordered').click(function(){
			ga('send', 'event', 'Engage For Peace', 'Click on CTA Engage For Peace', 'Header');
		});
		$('footer .footer-menu>ul>li.bordered').click(function(){
			ga('send', 'event', 'Engage For Peace', 'Click on CTA Engage For Peace', 'Footer');
		});
		$('body.home section#act-for-peace .col-sm-4:first-of-type a.bordered').click(function(){
			ga('send', 'event', 'Engage For Peace', 'Click on Donate', 'Home');
		});
		
		$('body.home section#act-for-peace .col-sm-4:nth-of-type(2) a.bordered').click(function(){
			ga('send', 'event', 'Engage For Peace', 'Click on Tell a friend', 'Home');
		});
		
		$('body.home section#act-for-peace .wpcf7 form').submit(function(){
			ga('send', 'event', 'Engage For Peace', 'Sending Form', 'Home');
		});
		$('body.home section#act-for-peace .col-sm-4:last-of-type a.bordered').click(function(){
			ga('send', 'event', 'Engage For Peace', 'Click on Share', 'Home');
		});
		$('body.page-template-act-for-peace section#act-for-peace .col-sm-4:first-of-type a.bordered').click(function(){
			ga('send', 'event', 'Engage For Peace', 'Click on Donate', 'Page Engage For Peace');
		});
		$('body.page-template-act-for-peace section#act-for-peace .col-sm-4:nth-of-type(2) a.bordered').click(function(){
			ga('send', 'event', 'Engage For Peace', 'Click on Tell a friend', 'Page Engage For Peace');
		});
		$('body.page-template-act-for-peace section#act-for-peace .wpcf7 form').submit(function(){
			ga('send', 'event', 'Engage For Peace', 'Sending Form', 'Page Engage For Peace');
		});
		$('body.page-template-act-for-peace section#act-for-peace .col-sm-4:last-of-type a.bordered').click(function(){
			ga('send', 'event', 'Engage For Peace', 'Click on Share', 'Page Engage For Peace');
		});
		$('body.page-template-donate main form').submit(function(){
			ga('send', 'event', 'Engage For Peace', 'Process Payment', '');
		});
		$('body.contact main .wpcf7-form').submit(function(){
			ga('send', 'event', 'Contact', 'Sending Contact Form', '');
		});
		$('body.page-template-become-partner main .wpcf7-form').click(function(){
			ga('send', 'event', 'Contact', 'Sending Become a Partner Form', '');
		});



});